import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useWindowSize from '~/components/hooks/useWindowSize';

import { api_getBannersByBannerGroupName } from '~/backend/api_calls';
import { convertImageUrl_L_to_F } from '~/backend/helper';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// import required modules
import { Navigation, Pagination } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { SportSliderLoader } from '~/components/common/SkeletonLoaders';

const SportsSlider = () => {
	const groupname = 'SportsSlider';
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const [banners, setBanners] = useState([]);

	useEffect(() => {
		api_getBannersByBannerGroupName(groupname)
			.then(json => {
				setBanners(json.items);
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	if (banners.length == 0) {
		return (
			<div className="content-wrapper">
				<SportSliderLoader />
			</div>
		);
	}
	return (
		<div className="sportsslider">
			<div className="content-wrapper">
				<h2 className="title">{t('homepage_sports_section')}</h2>

				{width >= 992 ? (
					<Swiper
						slidesPerView={'auto'}
						spaceBetween={10}
						pagination={{ clickable: true }}
						navigation={true}
						modules={[Pagination, Navigation]}
						className="sports-swiper">
						{banners?.map((banner, index) => (
							<SwiperSlide key={index}>
								{banner.nu ? (
									<Link to={banner.nu}>
										<img
											src={convertImageUrl_L_to_F(banner.img1) ?? banner.img2}
											alt={banner.tl}
											loading="lazy"
											width="376px"
											height="376px"
										/>
									</Link>
								) : (
									<img
										src={convertImageUrl_L_to_F(banner.img1) ?? banner.img2}
										alt={banner.tl}
										loading="lazy"
										width="376px"
										height="376px"
									/>
								)}
							</SwiperSlide>
						))}
					</Swiper>
				) : (
					<div className="sports-container">
						{banners?.map((banner, index) => (
							<div key={index} className="sport">
								{banner.nu ? (
									<Link to={banner.nu}>
										<img src={convertImageUrl_L_to_F(banner.img1) ?? banner.img2} alt={banner.tl} loading="lazy" width="376px" />
									</Link>
								) : (
									<img src={convertImageUrl_L_to_F(banner.img1) ?? banner.img2} alt={banner.tl} loading="lazy" height="376px" />
								)}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default SportsSlider;
